<template>
    <vs-sidebar position-right parent="body" default-index="1" color="primary" class="sidebarx" spacer v-model="callHistoryConfig.isOpen" click-not-close id="view-call-history">
        <div class="flex items-center justify-between px-6 py-6">
            <h4 class="p-0 text-2xl font-bold">Call History</h4>
            <feather-icon icon="XIcon" @click.stop="closeSidebar" class="cursor-pointer"></feather-icon>
        </div>
        <vs-divider class="mb-0 mt-3"></vs-divider>
        <div class="overflow-auto" style="height: calc(100vh - 110px);" v-if="callHistory && callHistory.length > 0">
            <div v-for="(item, index) in callHistory" :key="index" class="px-6 py-4 border-bottom-custom cursor-pointer call-item"
                :class="{'text-danger': item.direction == 'incoming' && item.state != 'call.hangup.normal_clearing'}"
                 @click="openCallingPopup(item.from)">
                <div class="flex justify-center justify-between w-full mt-1">
                    <div class="pr-2">
                        <p class="text-black font-bold mb-2" v-if="item.direction == 'incoming'">{{ item.from_name }}</p>
                        <p class="text-black font-bold mb-2" v-else>{{ item.to_name }}</p>
                        <div class="flex align-center">
                            <p class="text-sm">
                                <span v-if="item.state == 'call.hangup.normal_clearing'">
                                    <feather-icon icon="PhoneIncomingIcon" svgClasses="h-4 w-4 mr-1 font-bold text-success" v-if="item.direction == 'incoming'" />
                                    <feather-icon icon="PhoneOutgoingIcon" svgClasses="h-4 w-4 mr-1 font-bold text-primary" v-else />
                                </span>
                                <span v-else-if="item.direction == 'incoming'">
                                    <feather-icon icon="PhoneMissedIcon" svgClasses="h-4 w-4 mr-1 font-bold text-danger" />
                                </span>
                                {{ phoneNumberFormat(item.from) }}
                            </p>

                            <vs-alert v-if="item.direction && item.state" :color="getCallingColorByStatus(item.state, item.direction)" class="flex align-center justify-center ml-3"
                                style="width: 90px; height: 30px !important; font-size: 12px">
                                {{ getCallingTextByStatus(item.state, item.direction) }}
                            </vs-alert>
                        </div>
                    </div>
                    <div class="text-sm text-right flex flex-col justify-between">
                        <p>{{dateAgo((item.start_time))}}</p>
                        <p class="text-sm mt-2">{{ formatDateTime(item.start_time) }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-center mt-base pt-base" v-else>No data available</div>
    </vs-sidebar>
</template>

<script>
import { changeFormatWithDateTime } from '../../helper/datetimeHelper';
import { StringHelper } from '../../models/string_helper';
export default {
    name: "vs-view-call-history",
    props: {
        callHistoryConfig: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            StringHelper,
            isOpenLoading: false
        }
    },
    watch: {
        callHistoryConfig: {
            immediate: true,
            deep: true,
            handler() {
                if (this.callHistoryConfig.isOpen) {
                    this.$store.dispatch("call/GET_CALL_HISTORY");
                    document.body.classList.add("overflow-hidden");
                    document.body.style.position = "";
                    document.body.style.top = "";
                    window.scrollTo(0, parseInt(scrollY || "0") * -1);
                } else {
                    document.body.classList.remove("overflow-hidden");
                }
            }
        }
    },
    methods: {
        openLoadingInDiv() {
            this.$vs.loading({
                container: "#app",
                scale: 0.8
            });
            if (this.loadTime) {
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout(() => {
                if (this.isOpenLoading) {
                this.closeLoading();
                this.$vs.dialog({
                    color: "danger",
                    title: "Notification",
                    text: "Get data failed",
                    acceptText: "OK"
                });
                }
            }, 10000);
        },
        closeLoading() {
            this.isOpenLoading = false;
            setTimeout(() => {
                this.$vs.loading.close("#app > .con-vs-loading");
            }, 500);
        },
        formatDateTime(date) {
            if(date) {
                return changeFormatWithDateTime(date);
            }
            return 'N/A';
        },
        dateAgo(created_at) {
            let create = new Date(created_at);
            let currentDate = new Date();
            let type = "";
            let Difference_In_Time = currentDate.getTime() - create.getTime();
            let Difference_In_Day = 0;
            let Difference_In_Days = Difference_In_Time / (1000 * 3600);
            if (Difference_In_Days < 24) {
                Difference_In_Day = Difference_In_Days;
                type = "h ago";
            }
            if (Difference_In_Days >= 24) {
                Difference_In_Day = Difference_In_Days / 24;
                type = " days ago";
            }
            if (Difference_In_Days >= 720) {
                Difference_In_Day = Difference_In_Days / 720;
                type = " months ago";
            }
            if (Difference_In_Days >= 720 * 12) {
                Difference_In_Day = Difference_In_Days / (720 * 12);
                type = " years ago";
            }
            return Math.round(Difference_In_Day) + type;
        },
        closeSidebar() {
            this.callHistoryConfig.isOpen = false;
            // this.$emit("Unread");
        },
        phoneNumberFormat(str) {
            if(str && str != "") {
                let phone = str.slice(-10);
                return StringHelper.phoneNumberFormat(phone);
            }
            return 'N/A';
        },
        openCallingPopup(str) {
            if(str && str != "") {
                let params = {
                    phone: str.slice(-10)
                }
                this.openLoadingInDiv();
                this.$store.dispatch("customerList/GET_CUSTOMER_CALLING_INFO", params).then(() => {
                    this.closeSidebar();
                    this.closeLoading();
                    this.$emit('openCallingPopup');
                });
            } 
        },
        getCallingColorByStatus(state, direction) {
            if(state == "call.hangup.normal_clearing") {
                if(direction == "incoming") {
                    return "success";
                } else {
                    return "primary";
                }
            } else if(direction == "incoming") {
                return "danger";
            }
            return "primary";
        },
        getCallingTextByStatus(state, direction) {
            if(state == "call.hangup.normal_clearing") {
                if(direction == "incoming") {
                    return "In";
                } else {
                    return "Out";
                }
            } else if(direction == "incoming") {
                return "Missed";
            }
            return "N/A";
        }
    },
    computed: {
        config() {
            return this.$store.getters["auth/config"];
        },
        callHistory() {
            return this.$store.getters["call/callHistory"];
        }
    },
}
</script>
